import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    // 图片数据(图片url组成的数组) 通过v-model传递
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      isUploading: false,
      imgList: '',
      uploadData: {
        accept: '.mp4',
        data: {
          token: '',
          key: ''
        },
        class: 'avatar-uploader d2-mr',
        action: 'https://up-z2.qiniup.com',
        'show-file-list': false,
        multiple: false
      }
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getQiNiu();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  watch: {
    value: function value(a) {
      this.imgList = this.value;
    }
  },
  methods: {
    clickDel: function clickDel() {
      this.imgList = '';
      this.$emit('update:src', '');
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'video')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    // 上传完单张图片
    handleSuccess: function handleSuccess(res, file, fileList) {
      if (res.key) {
        this.imgList = this.VUE_APP_IMG_BASE + res.key;
        this.$emit('update:src', this.imgList);
      } else {
        this.$notify.error({
          title: '失败',
          message: res.msg
        });
      }

      this.isUploading = false;
    }
  }
};